import React from 'react';
import userInfoImg from "../../assets/imgs/userInfo.jpg"
import userImg from '../../assets/imgs/username.gif'

const UserInfo = () => {
    return (
        <div className="userInfo">
            <div className="header">
                <div className="img">
                    <img src={userInfoImg} alt="背景" />
                </div>
            </div>
            <div className="headtitle">
                {/* <div className="icon">
                    <img src={userImg} alt="头像" />
                </div> */}
                <h3>瑞安地名文化展示窗口</h3>
            </div>
            <div className="content">
                <div className="Introduction">
                    <h3>系统简介</h3>
                    <div className="message">
                    以文化视角透视地名文化(遗产)魅力，从地理、历史、诗词、民俗等各个角度，展示瑞安千年古县的万千风貌。通过探究地名文化，深入地名背后的历史文化、经济兴衰、风物演变、民俗风情、方言谚语、故事等，让地名得到大众关注。唤起根植于人们心中的家乡情结与热土情怀
                    </div>
                </div>
                <div className="information">
                    <div className="label">
                        单位：<span>瑞安市民政局</span>
                    </div>
                    <div className="label">
                        运营：<span>瑞安市云江区划地名研究院</span>
                    </div>
                    <div className="label">
                    地址：<span>浙江省瑞安市仓前街134号</span>
                    </div>
                </div>
               
            </div>
        </div>

    );
};

export default UserInfo;